export default __webpack_public_path__ + "631c1d5c3340e1ab4960c82cdd069c06.png";